/**
 * @generated SignedSource<<0844ee98f111057cc57c406d2e0c4c0e>>
 * @relayHash 69a28931ecb1e9e645d5105ddb690178
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d559b64c93c76b82b8460753885ee0b3f0f99a9411c0244057f7e75351b2fad6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentBrowseIntents788BadPatternQuery } from './VirtualAgentBrowseIntents788BadPatternQuery.graphql';

import newPerformancePage_provider from '@atlassian/jira-relay-provider/src/jsm-va-enable-performance-page.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentBrowseIntents788BadPatternQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d559b64c93c76b82b8460753885ee0b3f0f99a9411c0244057f7e75351b2fad6",
    "metadata": {},
    "name": "VirtualAgentBrowseIntents788BadPatternQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableperformancepagerelayprovider": newPerformancePage_provider
    }
  }
};

export default node;
